import React from "react";
import styles from "./styles/stem-result-item.module.scss";
import playIcon from "@/assets/music-player/play.svg";
import stopIcon from "@/assets/music-player/stop-pressed.svg";
import downloadIcon from "@/assets/icons/download-icon.svg";
import Image from "next/image";
import Loader from "@/components/common/loader";
import { useDownload } from "@/hooks/use-download";
import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import WavePlayerProgress from "@/components/common/music-player/wave-player-progress";
import { useWaveSurfer } from "@/hooks/music-players/use-wave-surfer";
import { stemSplitterLicenseManager } from "@/services/license/license-managers/stem-splitter-license-manager";
import { getFileNameFromUrl } from "@/utils/history-helper";
import ShareCoverButton from "@/components/common/share-cover-button";
import shareIcon from "@/assets/icons/share-icon.svg";
import { FeatureType } from "@/app/(home)/shared/[featureType]/[id]/page";

type StemResultItemProps = {
  url: string;
  stem: string;
  id?: string;
  featureType?: FeatureType | undefined;
};

const StemResultItem = ({
  url,
  stem,
  id,
  featureType,
}: StemResultItemProps) => {
  const { download } = useDownload();
  const { license, isLoading } = useProfileContext();
  const { isItemLoading, isPlaying, togglePlay, ...props } = useWaveSurfer(url);

  const shareButton = featureType && (
    <ShareCoverButton featureType={featureType} contentId={id} url={url}>
      <Image src={shareIcon} alt={""} />
    </ShareCoverButton>
  );

  return (
    <>
      {isItemLoading && <Loader size={"66px"} />}
      <div
        className={styles.waveform_player}
        style={{ visibility: isItemLoading ? "hidden" : "visible" }}
      >
        <button onClick={togglePlay} className={styles.play_button}>
          <Image
            className={styles.play_button}
            src={isPlaying ? stopIcon : playIcon}
            alt={"play-pause"}
          />
        </button>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            gap: "12px",
          }}
        >
          <div className={styles.stem_title}>{stem}</div>
          <WavePlayerProgress displayTime={true} {...props} />
        </div>
        {stemSplitterLicenseManager.downloadResultLimiter.isDownloadEnabled(
          license,
        ) &&
          !isLoading && (
            <button
              onClick={() =>
                download(
                  url,
                  getDownloadFilename(stem, getFileNameFromUrl(url, stem)),
                )
              }
              className={styles.download_button}
            >
              <Image src={downloadIcon} alt={"download"} />
            </button>
          )}
        {shareButton}
      </div>
    </>
  );
};

const getDownloadFilename = (stem: string, fileName: string) => {
  return `${stem}_${fileName}`;
};

export default StemResultItem;
